<template>
  <div class="home-page">
    <Sticky>
      <div class="sticky-header">
        <NavBar />
        <div class="main-image-wrapper col-lg-12 col-12 mx-auto p-0 d-flex">
          <b-carousel
            id="carousel-1"
            :interval="6000"
            controls
            fade
            class="hero-carousel"
          >
            <b-carousel-slide img-src="/banner-1.png"></b-carousel-slide>
            <b-carousel-slide img-src="/banner-2.png"></b-carousel-slide>
            <b-carousel-slide img-src="/banner-3.png"></b-carousel-slide>
          </b-carousel>
        </div>

        <div class="marquee-bar">
          <i class="fas fa-volume-up marquee-icon"></i>
          <NoticeBar
            class="notice-bar col-lg-10 col-10 mx-0 px-0 mx-auto"
            scrollable
            :text="websiteInfo[0]?.noticeText"
            background="transparent"
            v-if="!threedData.embedded_link && !threedData.isLive"
          />
        </div>
      </div>
    </Sticky>

    <div class="cards-container-mobile main-content-area">
      <!-- Horizontal category tabs (replaces left sidebar) -->
      <div class="category-tabs-wrap">
        <div class="category-tabs">
          <button
            v-if="
              websiteInfo[0] &&
              websiteInfo[0].disable_json &&
              (websiteInfo[0].disable_json.card[0].is_open ||
                websiteInfo[0].disable_json.card[1].is_open)
            "
            type="button"
            class="category-tab"
            :class="{
              active:
                sideNav === 'cardGames' ||
                sideNav === 'skm' ||
                sideNav === 'bugyi',
            }"
            @click="
              $playSound();
              changeSideNav('cardGames');
            "
          >
            <img src="/pocker-nav.png" alt="" class="category-tab-icon" />
            <span>{{ $t("home.card") }}</span>
          </button>
          <button
            v-if="
              websiteInfo[0] &&
              websiteInfo[0].disable_json &&
              (websiteInfo[0].disable_json.slots[0].is_open ||
                websiteInfo[0].disable_json.slots[1].is_open)
            "
            type="button"
            class="category-tab"
            :class="{ active: sideNav === 'slot' }"
            @click="
              $playSound();
              changeSideNav('slot');
            "
          >
            <img src="/slot-nav.png" alt="" class="category-tab-icon" />
            <span>{{ $t("home.slot") }}</span>
          </button>
          <button
            v-if="
              websiteInfo[0] &&
              websiteInfo[0].disable_json &&
              websiteInfo[0].disable_json.fishing[0].is_open
            "
            type="button"
            class="category-tab"
            :class="{ active: sideNav === 'fishing' }"
            @click="
              $playSound();
              changeSideNav('fishing');
            "
          >
            <img src="/fishing-nav.png" alt="" class="category-tab-icon" />
            <span>{{ $t("home.fishing") }}</span>
          </button>
          <button
            v-if="
              websiteInfo[0] &&
              websiteInfo[0].disable_json &&
              websiteInfo[0].disable_json.fishing[0].is_open
            "
            type="button"
            class="category-tab"
            :class="{ active: sideNav === 'buffalo' }"
            @click="
              $playSound();
              changeSideNav('buffalo');
            "
          >
            <img src="/buffalo-nav.png" alt="" class="category-tab-icon" />
            <span>{{ $t("home.buffalo") }}</span>
          </button>
        </div>
      </div>

      <div class="content-layout container-fluid">
        <main class="index_rightbar main-fullwidth" id="index_rightbar">
          <div
            class="room-cards-grid"
            :class="sideNav === 'skm' ? 'active' : ''"
            v-show="sideNav === 'skm'"
          >
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
              alt="skm"
              @click="
                $playSound();
                fetchShanKoMeeData(0);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchShanKoMeeData(1);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchShanKoMeeData(2);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
              alt="skm"
              @click="
                $playSound();
                fetchShanKoMeeData(3);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchShanKoMeeData(4);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchShanKoMeeData(5);
              "
            />
          </div>

          <div
            class="room-cards-grid"
            :class="sideNav === 'bugyi' ? 'active' : ''"
            v-show="sideNav === 'bugyi'"
          >
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
              alt="skm"
              @click="
                $playSound();
                fetchBugyee(0);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchBugyee(1);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchBugyee(2);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
              alt="skm"
              @click="
                $playSound();
                fetchBugyee(3);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchBugyee(4);
              "
            />
            <img
              class="room-card-img"
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
              alt="skm"
              @click="
                $playSound();
                fetchBugyee(5);
              "
            />
          </div>

          <div v-if="sideNav !== 'skm' && sideNav !== 'bugyi'">
            <div class="tab-content game">
              <section
                class="game-section cardGames"
                v-if="
                  websiteInfo[0].disable_json.card[0].is_open ||
                  websiteInfo[0].disable_json.card[1].is_open
                "
              >
                <h2 class="section-title">
                  <img class="section-icon" src="/poker.png" alt="" />
                  {{ $t("home.card_game") }}
                </h2>

                <div
                  class="mt-4 game-cards-row"
                  :class="sideNav === 'cardGames' ? 'active' : ''"
                >
                  <div class="game-card">
                    <img
                      class="game-card-img"
                      v-if="websiteInfo[0].disable_json.card[0].is_open"
                      src="/ShanKoeMee-Card.png"
                      alt="slot"
                      style="cursor: pointer; width: 100%; height: auto"
                      @click="
                        $playSound();
                        changeSideNav('skm');
                      "
                    />
                  </div>
                  <div class="game-card">
                    <img
                      class="game-card-img"
                      v-if="websiteInfo[0].disable_json.card[1].is_open"
                      src="/Bugyi-Card.png"
                      alt="slot"
                      style="cursor: pointer; width: 100%; height: auto"
                      @click="
                        $playSound();
                        changeSideNav('bugyi');
                      "
                    />
                  </div>
                </div>
              </section>

              <div
                class="section-divider"
                v-if="
                  websiteInfo[0].disable_json.card[0].is_open ||
                  websiteInfo[0].disable_json.card[1].is_open
                "
              />
              <section
                class="game-section slot"
                v-if="
                  websiteInfo[0].disable_json.slots[0].is_open ||
                  websiteInfo[0].disable_json.slots[1].is_open
                "
              >
                <h2 class="section-title">
                  <img class="section-icon" src="/slot.png" alt="" />
                  {{ $t("home.slot") }}
                </h2>
                <div
                  class="game-cards-row mt-4"
                  :class="sideNav === 'slot' ? 'active' : ''"
                >
                  <div
                    class="game-card"
                    v-if="websiteInfo[0].disable_json.slots[0].is_open"
                  >
                    <img
                      class="game-card-img"
                      src="/Pragmatic-Play-Slot.png"
                      alt="slot"
                      style="cursor: pointer; width: 100%; height: auto"
                      @click="
                        $playSound();
                        $router.push('/user/slots?provider=Pragmatic');
                      "
                    />
                  </div>
                  <div
                    class="game-card"
                    v-if="websiteInfo[0].disable_json.slots[1].is_open"
                  >
                    <img
                      class="game-card-img"
                      src="/Jilli-Slot.png"
                      alt="slot"
                      style="cursor: pointer; width: 100%; height: auto"
                      @click="
                        $playSound();
                        $router.push('/user/slots?provider=Jili');
                      "
                    />
                  </div>
                </div>
              </section>

              <div
                class="section-divider"
                v-if="
                  websiteInfo[0].disable_json.slots[0].is_open ||
                  websiteInfo[0].disable_json.slots[1].is_open
                "
              />
              <section
                class="game-section fishing"
                v-if="websiteInfo[0].disable_json.fishing[0].is_open"
              >
                <h2 class="section-title">
                  <img class="section-icon" src="/fishing.png" alt="" />
                  {{ $t("home.fishing") }}
                </h2>
                <div
                  class="game-cards-row mt-4"
                  :class="sideNav === 'fishing' ? 'active' : ''"
                >
                  <div class="game-card">
                    <img
                      class="game-card-img"
                      src="/Jilli-Fishing.png"
                      alt="slot"
                      style="cursor: pointer; width: 100%; height: auto"
                      @click="
                        $playSound();
                        $router.push('/user/fishing?provider=Jili');
                      "
                    />
                  </div>
                </div>
              </section>
              <div
                class="section-divider"
                v-if="
                  websiteInfo[0].disable_json.slots[0].is_open ||
                  websiteInfo[0].disable_json.slots[1].is_open
                "
              />
              <section
                class="game-section fishing buffalo"
                v-if="websiteInfo[0].disable_json.fishing[0].is_open"
              >
                <h2 class="section-title">
                  <img class="section-icon" src="/buffalo.png" alt="" />
                  {{ $t("home.buffalo") }}
                </h2>
                <div
                  class="game-cards-row mt-4"
                  :class="sideNav === 'buffalo' ? 'active' : ''"
                >
                  <div class="game-card">
                    <img
                      class="game-card-img"
                      src="/buffalo-card.png"
                      alt="slot"
                      style="cursor: pointer; width: 100%; height: auto"
                      @click="
                        $playSound();
                        $router.push('/user/buffalo?provider=Buffalo');
                      "
                    />
                  </div>
                </div>
              </section>

              <!-- <hr>
                  <div class="slot">
                    <div class="d-flex pt-3 pl-2 ">
                      <img style="width: auto; height: 35px;" src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/yyr_cards/icons/Slot%20Icon.png" alt="">
                      <div class="pl-2 py-0 my-auto font-weight-450 text-dark" style="font-size: 1.2rem;">{{$t('home.slot_game')}}</div>
                    </div>

                    <div class="my-3 mb-5" :class="sideNav === 'slot' ? 'active' : ''">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/108c0373-fb77-4770-320b-811e4ec18700/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=Pragmatic')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/9b119594-83c5-45a2-fbcd-3bbfd18e4700/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=Jili')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/83f5e10b-79bf-46aa-ccdb-800a4aef3100/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=5G')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/af94115e-9812-4b43-b12f-5d8f2a40bf00/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=JDB')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/e6203699-3213-44f4-c9db-02b7f89b0f00/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=FaChai')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/80a5d5e1-d768-441c-5ba2-6535f2ea4800/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=JOKER')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/91fb9c94-b5af-4f43-3867-b45090b10d00/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/slots?provider=PGSoft')">
                    </div>
                  </div> -->

              <!-- <hr>
                  <div class="fishing">
                    <div class="d-flex pt-3 pl-2">
                      <img style="width: auto; height: 35px;" src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/yyr_cards/icons/Fishing%20Slot%20Icon.png" alt="">
                      <div class="pl-2 py-0 my-auto font-weight-450 text-dark" style="font-size: 1.2rem;">{{$t('home.fishing_game')}}</div>
                    </div>

                    <div class="pb-3 mt-2" :class="sideNav === 'fishing' ? 'active' : ''">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c7009e2-aa9d-436e-5ec4-4160602e5200/public" alt="skm" style="cursor: pointer; width: 50%; height: auto;"  @click="$playSound(); $router.push('/user/fishing?provider=Jili')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dbe9746b-f477-44ee-e436-97c5cee1c400/public" class="mt-3" alt="skm" style="cursor: pointer; width: 50%; height: auto;" @click="$playSound(); $router.push('/user/fishing?provider=JDB')">
                    </div>
                  </div> -->

              <!-- <hr>
                  <div class="casino">
                    <div class="d-flex pt-3 pl-2 ">
                      <img style="width: auto; height: 35px;" src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/yyr_cards/icons/Casino%20Icon.png" alt="">
                      <div class="pl-2 py-0 my-auto font-weight-450 text-dark" style="font-size: 1.2rem;">{{$t('home.live_casino')}}</div>
                    </div>

                    <div class="mx-1 pb-2" :class="sideNav === 'casino' ? 'active' : ''">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/51c24a1d-451b-4dc0-db76-69a43bd00400/public" alt="casino" style="cursor: pointer; width: 100%; height: auto; margin-top: -0.2rem;" @click="$playSound(); gameInit('PP Live')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/fb177a01-62ba-47c2-b58b-9df8a178d900/public" alt="casino" style="cursor: pointer; width: 100%; height: auto; margin-top: -2.4rem;" @click="$playSound(); gameInit('WM')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/d7e037ce-626c-48cb-cfd5-0ffbcf75ff00/public" alt="casino" style="cursor: pointer; width: 100%; height: auto; margin-top: 0.7rem;" @click="$playSound(); gameInit('Sexy')">
                      <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/defa98b6-643e-499a-f4de-c9280c7e5200/public" alt="casino" style="cursor: pointer; width: 100%; height: auto; margin-top: -2.5rem;" @click="$playSound(); showAlertBox('BG')">
                    </div>
                              <div class="col-4">
                                <div
                                    class="modal fade"
                                    id="limit"
                                    tabindex="-1"
                                    role="dialog"
                                    aria-labelledby="modal-form"
                                    @click="hideLimit()"
                                >
                                    <div
                                        class="modal-dialog modal- modal-dialog-centered"
                                        role="document"
                                    >
                                        <div class="modal-content">
                                            <div class="modal-body my-5 mx-3 text-center">
                                            <span class="text-danger text-lg">
                                                <b>အထူးသတိပြုရန်။</b> <br><br>
                                            </span>
                                            <span>{{limitText}}</span>
                                            <br><br> <span class="text-dark text-sm">
                                                <button class="btn btn-danger" @click="gameInit(desiredGame)">
                                                {{
                                                    $store.state.language === "en"
                                                        ? "Play The Game"
                                                        : "ဂိမ်းဆော့မည်။"
                                                }}
                                                </button>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                  </div> -->
              <!-- <hr>
                  <div class="vs pb-4">
                    <div class="d-flex pt-3 pl-2">
                      <img style="width: auto; height: 35px;" src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/yyr_cards/icons/Casino%20Icon.png" alt="">
                      <div class="pl-2 py-0 my-auto font-weight-450 text-dark" style="font-size: 1.2rem;">VS</div>
                    </div>
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/723ca88a-6cf0-406b-d7b3-a93d023f6f00/public" alt="slot" style="cursor: pointer; width: 103%; margin-left: -0.4rem; height: auto;" @click="$playSound(); gameInit('CockFight')">
                  </div> -->
            </div>
          </div>
        </main>
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#ffffff" class="mx-auto" />
      </div>
    </van-overlay>

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div class="modal-dialog modal- modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>{{ $t("skm.title") }}</b> <br /><br />
              </span>

              <span>{{ limitText }}</span>
              <br /><br />
              <span class="text-dark text-sm">
                <button class="btn btn-danger" @click="hideLimit()">
                  {{ $t("okay") }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import NavBar from '@/layouts/NavBar.vue';
import { NoticeBar, Dialog, Toast, Sticky } from "vant";
import { mapActions, mapState } from "vuex";

export default {
  components: { NoticeBar, Sticky },
  data() {
    return {
      comingSoonShow: false,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {},
      isLogged: false,
      // sideNav: 'card',
      limitText: null,
      desiredGame: null,
    };
  },
  computed: {
    ...mapState(["sideNav"]),
  },

  methods: {
    comingSoon() {
      this.comingSoonShow = !this.comingSoonShow;
    },
    hideLimit() {
      $("#limit").modal("hide");
    },

    showAlertBox(game) {
      if (game === "BG")
        this.limitText =
          "BG Live Casino တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။";
      $("#limit").modal("show");
      this.desiredGame = game;
    },

    getCountry() {
      fetch("https://ipinfo.io/json")
        .then((response) => response.json())
        .then((data) => {
          // this.country = data.country;
          console.log(data);
        })
        .catch((error) => console.error("Error fetching country data:", error));
    },
    hideLimit() {
      $("#limit").modal("hide");
    },

    changeSideNav(para) {
      this.$store.commit("updateSideNav", para);
      this.$nextTick(() => {
        this.scrollToElement(para);
      });
    },

    scrollToElement(className) {
      const container = this.$el.querySelector(".index_rightbar");
      if (!container) return;
      const targetElement = container.querySelector("." + className);

      if (targetElement) {
        const containerRect = container.getBoundingClientRect();
        const targetRect = targetElement.getBoundingClientRect();
        const top = targetRect.top - containerRect.top + container.scrollTop;
        let offset = 0;
        if (className === "lottery") offset = 20;
        else if (["cardGames", "slot", "fishing", "buffalo"].includes(className))
          offset = 16;
        container.scrollTo({
          top: Math.max(0, top - offset),
          behavior: "smooth",
        });
      }
    },

    scrollMeTo(refName) {
      document.getElementById("index_rightbar").scrollTo({
        top: 0,
        behavior: "smooth", // This creates the smooth scrolling effect
      });
    },

    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game;
          this.gameLink = link;
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
        });
        window.location.assign(
          `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`,
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText =
            "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText =
            "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText =
            "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText =
            "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText =
            "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText =
            "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        const res = await axios.get("/bugyee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        // window.location.assign(res.data.url)
        window.top.location.href = res.data.url;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText =
            "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText =
            "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText =
            "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText =
            "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText =
            "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText =
            "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/shankomee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        // window.location.assign(res.data.url)
        window.top.location.href = res.data.url;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async gameInit(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const res = await axios.get("/games/url", {
          params: {
            provider: game,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        // window.open(res.data.data.gameUrl, "_self");
        // this.$store.commit('setIframeURL', res.data.data.gameUrl);
        // this.$store.commit('setIsCardGame', false);
        // this.$router.push('/iframeURL');

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        // this.$router.go();
      }
    },
    ...mapActions(["logoutUser", "fetchUser"]),
    async redirectRoute(path, query = null) {
      try {
        console.log("query", query);
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure to log out?"
            : "ထွက်မှာ သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မထွက်တော့ပါ",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ",
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push("/auth/login");
          Toast.success(
            this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ",
          );
        })
        .catch(() => {});
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === "tip") {
          const text =
            this.$store.state.language === "en"
              ? "This feature is not support yet."
              : "ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။";
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === "en" ? "Okay" : "Okay",
          }).then(() => {
            // on close
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format("ll");
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get("/2d/data");
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        this.websiteInfo = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get("/3d/data");
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get("/twod_history");
        const threeDres = await axios.get("/threed_history");
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },

    observeMultipleElements(classNames) {
      // Iterate over each class name and observe the corresponding element
      classNames.forEach((className) => {
        // Create an IntersectionObserver for each element
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.onElementInView(className); // Call function for the specific class in view
              }
            });
          },
          {
            threshold: 0.8, // Trigger when 10% of the target div is visible
          },
        );

        // Find the element with the current class name and start observing it
        const target = this.$el.querySelector(`.${className}`);
        if (target) {
          observer.observe(target);
        }
      });
    },
    onElementInView(className) {
      this.$store.commit("updateSideNav", className);
    },
  },
  async mounted() {
    this.fetchWebsiteData();
    // this.getCountry();
    // const authUser = await this.fetchUser();
    // if (authUser) {
    //   this.isLogged = true;
    // }
    this.scrollToElement(this.$store.state.sideNav);
    this.observeMultipleElements([
      "fishing",
      "casino",
      "football",
      "slot",
      "lottery",
      "cardGames",
      "vs",
    ]);
  },
};
</script>
<style scoped>
/* ========== Page & layout ========== */
.home-page {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(180deg, #f0f4f8 0%, #e8eef5 50%, #f5f7fa 100%);
  padding-bottom: 0;
}
.home-page > *:first-child {
  flex-shrink: 0;
}

.sticky-header {
  background: #fff;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
}

.hero-carousel {
  width: 100%;
  height: 100%;
}
.main-image-wrapper {
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  height: 20vh;
  max-height: 160px;
  background: #e8eef5;
}

.main-image-wrapper::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40%;
  pointer-events: none;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.08) 0%, transparent 100%);
  border-radius: 0 0 16px 16px;
}
.main-image-wrapper :deep(.carousel),
.main-image-wrapper :deep(.carousel-inner),
.main-image-wrapper :deep(.carousel-item),
.main-image-wrapper :deep(img) {
  border-radius: 0 0 16px 16px;
}
.main-image-wrapper :deep(.carousel),
.main-image-wrapper :deep(.carousel-inner),
.main-image-wrapper :deep(.carousel-item) {
  height: 100%;
}
.main-image-wrapper :deep(img) {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 0px !important;
  object-position: center center;
}

/* ========== Marquee ========== */
.marquee-bar {
  display: flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 8px;
  margin: 5px 0px;
  min-height: 26px;
  background: linear-gradient(105deg, #1a56b0 0%, #2282e8 50%, #4da0f5 100%);
  box-shadow: 0 2px 12px rgba(34, 130, 232, 0.2);
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.marquee-icon {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.95);
  margin-right: 6px;
  flex-shrink: 0;
}
.notice-bar {
  z-index: 1;
  font-size: 13px;
  font-weight: 500;
  color: #fff !important;
  background: transparent !important;
  letter-spacing: 0.02em;
  min-height: 0;
  line-height: 1.35;
}
.marquee-bar :deep(.van-notice-bar),
.notice-bar :deep(.van-notice-bar) {
  background: transparent !important;
  color: #fff !important;
  min-height: 0 !important;
  padding: 2px 0 !important;
  line-height: 1.35 !important;
}
.marquee-bar :deep(.van-notice-bar__left-icon),
.marquee-bar :deep(.van-notice-bar__right-icon) {
  font-size: 12px !important;
}

/* ========== Content layout ========== */
.content-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  margin-top: 0;
  padding: 0 6px 16px;
}

/* Horizontal category tabs (new layout) - full width, no white panel */
.category-tabs-wrap {
  width: 100%;
  flex-shrink: 0;
  padding: 8px 10px 10px;
  background: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.category-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 2px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.category-tabs::-webkit-scrollbar {
  display: none;
}
.category-tab {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 76px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 2px solid rgba(0, 0, 0, 0.06);
  background: #f8fafc;
  color: #475569;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.22s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.category-tab span {
  white-space: nowrap;
  overflow: visible;
}
.category-tab:hover {
  background: #e2e8f0;
  color: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}
.category-tab.active {
  background: #eff6ff;
  color: #1a56b0;
  border-color: #1a56b0;
  box-shadow: 0 2px 12px rgba(26, 86, 176, 0.2);
}
.category-tab-icon {
  width: 34px;
  height: auto;
  object-fit: contain;
  display: block;
}

.main-fullwidth {
  width: 100%;
  max-width: 100%;
}

/* ========== Main content ========== */
.index_rightbar {
  width: 100%;
  min-width: 0;
  flex: 1;
  overflow-y: auto;
  min-height: 60vh;
  overflow-x: hidden;
  padding: 0 4px;
  padding-bottom: 200px !important;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* Visible scrollbar on mobile - easier to see and use */
@media (max-width: 768px) {
  .index_rightbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(26, 86, 176, 0.5) rgba(0, 0, 0, 0.08);
  }
  .index_rightbar::-webkit-scrollbar {
    width: 8px;
  }
  .index_rightbar::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.06);
    border-radius: 4px;
  }
  .index_rightbar::-webkit-scrollbar-thumb {
    background: rgba(26, 86, 176, 0.5);
    border-radius: 4px;
    min-height: 48px;
  }
  .index_rightbar::-webkit-scrollbar-thumb:hover {
    background: rgba(26, 86, 176, 0.7);
  }
}

@media (min-width: 769px) {
  .index_rightbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .index_rightbar::-webkit-scrollbar {
    display: none;
  }
}

/* Room cards (New, Junior, Senior, Boss, etc.) - card game / bugyi */
.room-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 10px 6px 20px;
}
.room-card-img {
  width: 100%;
  height: auto;
  max-height: 96px;
  object-fit: contain;
  object-position: center;
  cursor: pointer;
  border-radius: 12px;
  display: block;
  background: #f1f5f9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.room-card-img:active {
  transform: scale(0.97);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.tab-content.game {
  padding: 8px 4px 16px;
  min-height: 0;
}

.game-section {
  margin-bottom: 14px;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px 0;
  padding: 4px 10px 4px 12px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  border-left: 4px solid #2282e8;
  background: linear-gradient(
    90deg,
    rgba(34, 130, 232, 0.08) 0%,
    rgba(34, 130, 232, 0.02) 60%,
    transparent 100%
  );
  border-radius: 0 10px 10px 0;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.section-icon {
  width: 20px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.06));
}
.section-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #e2e8f0 20%,
    #e2e8f0 80%,
    transparent 100%
  );
  margin: 10px 0;
  border: 0;
}
.game-cards-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.tab-content.game .game-cards-row.mt-4 {
  margin-top: 10px;
}
.game-card {
  /* Card games, slot, and fishing sections - image only, no white box */
  border-radius: 20px;
  overflow: hidden;
  background: #e8eef5;
  transition: transform 0.25s ease, filter 0.25s ease;
  border: none;
}
.game-card:hover {
  transform: translateY(-6px);
}
.game-card-img {
  /* Same treatment for all game card images (card / slot / fishing) */
  display: block;
  width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.3s ease;
  mix-blend-mode: darken;
}
.game-card:hover .game-card-img {
  transform: scale(1.04);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2), 0 8px 20px rgba(0, 0, 0, 0.12);
}

.main-content-area {
  width: 100%;
  max-width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
}

/* ========== Nav pills (fallback / legacy) ========== */
.nav-pills.game-nav {
  padding-right: 0;
  gap: 14px;
}
.nav-pills .nav-link {
  border-radius: 18px !important;
  margin-bottom: 0;
}
.nav-pills:not(.nav-pills-circle) .nav-item {
  width: 100%;
  max-width: 92px;
  padding-right: 0;
  margin-bottom: 0;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

/* ========== Legacy / utils ========== */
.side-nav-icon-box {
  width: 2.75rem;
  height: 2.75rem;
  min-width: 2.75rem;
  min-height: 2.75rem;
  border-radius: 12px;
  flex-shrink: 0;
}
.card {
  cursor: pointer;
  border-radius: 20px !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.25s ease;
}
.card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.09);
}
.video-container {
  height: 500px;
  width: 100%;
}
.twod-threed-cards {
  height: 200px;
}
.live-number {
  font-weight: bold;
  font-size: 25px;
}
.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation: live-number-animation 2s infinite;
}
.not-live-text {
  font-weight: bold;
  font-size: 24px;
}
.cards-container {
  display: flex;
  flex-wrap: wrap;
}
.card-body {
  padding: 0 !important;
}
.cards-container-mobile {
  display: none;
}
@keyframes live-number-animation {
  from {
    color: white;
  }
  to {
    color: red;
  }
}
.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid #2282e8;
  border-radius: 14px;
  color: #2282e8;
  cursor: pointer;
  padding: 10px 18px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.22s ease;
  letter-spacing: 0.02em;
}
.detail-button:hover {
  color: #fff;
  background-color: #2282e8;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(34, 130, 232, 0.35);
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.tab-content.game a img {
  border-radius: 20px;
  margin-bottom: 12px;
  width: 100%;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.25s ease;
}
.tab-content.game a:hover img {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.css-38745a {
  margin: 0;
  line-height: 1.5;
  font-size: 12px;
  font-weight: 500;
}
.css-17h40hp {
  margin: 0;
  line-height: 1.5;
  font-size: 14px;
  font-weight: 700 !important;
}

@media (max-width: 768px) {
  /* .middle-container {
    padding-top: 0.1rem !important;
  } */
  hr {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .video-container {
    height: 300px;
    width: 100%;
  }
  .main-wrapper {
    padding: 7px !important;
  }
  .notice-bar {
    margin-top: 0;
    min-height: 0;
    z-index: 1;
    font-size: 13px;
    font-weight: 500;
    color: #ffffff !important;
    background: transparent !important;
    border-radius: 0;
  }
  .live-number {
    font-weight: bold;
    font-size: 20px;
  }
  .live-result {
    font-weight: bolder;
    font-size: 37px;
  }

  .cards-container {
    display: none;
  }
  .cards-container-mobile {
    padding: 0 !important;
    margin-top: 2px !important;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .home-cards {
    padding-left: 6px;
    padding-right: 6px;
  }
  .card-body {
    padding: 0px !important;
  }
  .not-live-text {
    font-size: 18px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .account-container-wrapper {
    width: auto;
    height: auto;
    border-radius: 8px;
    padding-left: 4px;
    padding-right: 4px;
    margin-top: 6px !important;
    margin-left: 6px;
    margin-right: 6px;
    color: #000000;
    /* background: linear-gradient(#aa9ace, #714DC7); */
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  }
  .top-wrapper,
  .bottom-wrapper {
    padding: 8px;
    width: 100%;
    display: flex;
  }
  .top-right,
  .bottom-right {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: end;
  }
  .top-left,
  .bottom-left {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: start;
  }
}
</style>
